import * as React from "react";

const MailIcon = (props) => (
    <svg width={props.width} height={props.height} viewBox="0 0 54 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M52 7C52 4.25 49.75 2 47 2H7C4.25 2 2 4.25 2 7M52 7V37C52 39.75 49.75 42 47 42H7C4.25 42 2 39.75 2 37V7M52 7L27 24.5L2 7" stroke={props.stroke} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)

export default MailIcon